import React from 'react';
import Gallery from '../components/Gallery/Gallery';
import useAPI from '../hooks/useAPI';
import Loading from '../components/Loading/Loading';

const GalleryPage = () => {
  const {
    data: galleryData,
    loading,
    error,
  } = useAPI('/gallery');

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  console.log('Gallery Data:', galleryData);

  return (
    <div className="pt-20">
      <Gallery data={galleryData?.data} />
    </div>
  );
};

export default GalleryPage;